// extracted by mini-css-extract-plugin
export var container = "_y-0";
export var error = "_y-9";
export var label = "_y-5";
export var light = "_y-6";
export var md = "_y-3";
export var sm = "_y-2";
export var thin = "_y-8";
export var thinBold = "_y-7";
export var vertical = "_y-4";
export var xs = "_y-1";